import apiClient from '../apiClient';

/**
 * Queue API service
 */
export const queueApi = {
  /**
   * Fetch queue data for current room
   */
  fetchQueues: async () => {
    const data = await apiClient.get('/room/queue');
    return data;
  },

  /**
   * Perform a queue action (moveUp, moveDown, remove, moveAllUp)
   * @param {string} action - Queue action name
   * @param {number} lid - Library item ID
   */
  performQueueAction: async (action, lid) => {
    if (!lid) {
      throw new Error('Missing library ID for queue operation');
    }

    const numericLid = parseInt(lid, 10);
    if (isNaN(numericLid)) {
      throw new Error('Invalid library ID: must be a number');
    }

    const response = await apiClient.get(`/room/${action}`, {
      params: { lid: numericLid }
    });
    return response;
  },

  /**
   * Add a track to the queue
   * @param {string} trackId - Track UUID
   */
  queueAdd: async (trackId) => {
    if (!trackId) {
      throw new Error('Missing track ID for queue add operation');
    }

    const data = await apiClient.get('/room/queueAdd', {
      params: {
        trackId: String(trackId),
        messageUsers: true
      }
    });
    return data;
  }
};
